import { FC } from 'react'

import { twMerge } from 'tailwind-merge'

import { BADGE_SIZE_STYLES, BADGE_VARIANT_STYLES } from './constants'
import { BadgeProps } from './types'

export const Badge: FC<BadgeProps> = ({
  content,
  variant = 'danger',
  size = 'sm',
  className,
}) => {
  return (
    <div
      className={twMerge(
        'absolute -top-1 -right-1 flex items-center justify-center rounded-full font-medium leading-none',
        BADGE_VARIANT_STYLES[variant],
        BADGE_SIZE_STYLES[size],
        className,
      )}
      role="status"
      aria-label={`${content} notifications`}
    >
      {content}
    </div>
  )
}
